import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

export default forwardRef((props: any, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => setSelectedIndex(0), [props.items]);

  const selectItem = (index: number) => {
    const item = props.items[index];
    if (item) {
      props.command({ id: item.id, label: item.label });
    }
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: any) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }
      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }
      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }
      return false;
    },
  }));

  return (
    <div className="bg-primary-variant border border-primary-subtle rounded-lg shadow-lg overflow-hidden flex flex-col w-64 max-h-64 overflow-y-auto z-[999999]">
      {props.items.length > 0 ? (
        props.items.map((item: any, index: number) => (
          <button
            className={`flex items-center gap-3 w-full px-3 py-2 text-left text-sm transition-colors ${
              index === selectedIndex ? 'bg-primary-subtle text-white' : 'text-neutral hover:bg-primary-subtle'
            }`}
            key={index}
            onMouseDown={(e) => {
              e.preventDefault();
              selectItem(index);
            }}
          >
            {item.avatar ? (
              <img src={item.avatar} alt={item.label} className="w-6 h-6 rounded-full object-cover flex-shrink-0" />
            ) : (
              <div className="w-6 h-6 bg-blue-600/20 text-blue-500 rounded-full flex items-center justify-center font-medium text-xs flex-shrink-0">
                {item.label.charAt(0).toUpperCase()}
              </div>
            )}
            <div className="flex flex-col overflow-hidden">
              <span className="truncate font-medium leading-tight">{item.label}</span>
              <span className="truncate text-xs text-neutral-medium leading-tight mt-0.5">{item.email}</span>
            </div>
          </button>
        ))
      ) : (
        <div className="px-3 py-3 text-sm text-neutral-medium text-center">No results found</div>
      )}
    </div>
  );
});
